import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import ReleasePreview from "./ReleasePreview";
import { SonicDBEntryData } from "../../classes/SonicDBEntry";
import SinglePerson from "../../../features/person-single/SinglePerson";

import { CategoryState } from "../../../utils/CategoryState";
import { RequestState } from "../../../utils/RequestState";
import { getDefaultImage } from "../../../utils/GeneralUtils";
import { useGetTeamMembers } from "../../../utils/useTeam";

import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";
import {
  getPersonAdmin,
  approveEntry,
  getPersonData,
} from "../../../redux/reducers/person";

type Props = {
  isSelect: boolean;
};

export const ReleasePersonPreviewContainer: React.FC<Props> = ({
  isSelect,
}) => {
  const { id } = useParams<{ id: string }>();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [activeModal, setActiveModal] = useState<CategoryState>(
    CategoryState.None
  );
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Pending
  );
  const [message, setMessage] = useState<string>("");

  const dispatch = useAppDispatch();
  const person = useAppSelector(getPersonData)[0];
  const auth_token = useAppSelector(getAuthToken);

  const handleInputChange = (value: string) => {
    setMessage(value);
  };

  const showModal = (modal: CategoryState) => {
    setActiveModal(modal);
  };

  const closeModal = () => {
    setActiveModal(CategoryState.None);
    setRequestState(RequestState.Pending);
  };

  const handleSubmit = (approve: boolean) => {
    if (auth_token && id) {
      dispatch(
        approveEntry({
          auth_token: auth_token,
          id: id,
          message: message,
          approve: approve,
          is_jikei_request: !isSelect,
        })
      );

      setRequestState(RequestState.Success);
    }
  };

  useEffect(() => {
    if (auth_token && id) {
      const fetchDbEntry = dispatch(
        getPersonAdmin({
          auth_token: auth_token,
          is_jikei_request: !isSelect,
          id: id,
        })
      );

      let cancelled = false;

      fetchDbEntry.then(() => {
        if (cancelled) return;
        setIsLoading(false);
      });

      return () => {
        cancelled = true;
      };
    }
  }, []);

  // PreviewContainerでメンバーをフェッチしようとするとフックのエラーに抵触するので、専用のコンポーネントを作成
  type ContainerProps = {
    person: SonicDBEntryData;
  };

  const FetchContainer: React.FC<ContainerProps> = ({ person }) => {
    const { members } = useGetTeamMembers({
      // person.teamはtermデータなので、linkからチームのidを取得
      id:
        person?.team?.length && person.team[0].link
          ? person.team[0].link.split("/").pop()
          : undefined,
    });

    return (
      <SinglePerson
        id={person?.id}
        owner={person?.owner}
        ownerName={person?.ownerName}
        ownerChatDenial={person?.ownerChatDenial}
        img={
          person?.imgs?.[0]?.large?.url
            ? person.imgs[0].large.url
            : getDefaultImage()
        }
        name={person?.name}
        game={person?.game}
        team={person?.team?.[0] && person.team[0]}
        playerTypeName={person?.player_type?.[0]?.name}
        profile={person?.profile}
        birthplace={person?.birthplace}
        height={person?.height}
        weight={person?.weight}
        hobby={person?.hobby}
        history={person?.history}
        works={person?.works}
        twitter={person?.sns?.twitter?.toString()}
        instagram={person?.sns?.instagram?.toString()}
        facebook={person?.sns?.facebook?.toString()}
        youtube={person?.sns?.youtube?.toString()}
        twitch={person?.sns?.twitch?.toString()}
        school={person?.school}
        course={person?.course}
        verified={person?.verified}
        showOfferButton={false}
        members={
          // 公開申請はisLoading trueでもchildrenのpropsを検証するのでフェッチが終わった時のみ判定する
          // storeのデータとidが一致するときのみ自分を除いて表示
          !isLoading && person.id === id
            ? members.filter((member) => member.id !== id)
            : []
        }
        gameDetails={person?.game_details ?? []}
      />
    );
  };

  return (
    <>
      <ReleasePreview
        message={message}
        targetName={`${person?.name} / ${person?.kana ? person.kana : ""} `}
        modalLink={`/person/${id}`}
        activeModal={activeModal}
        requestState={requestState}
        closeModal={closeModal}
        showModal={showModal}
        handleSubmit={handleSubmit}
        handleInputChange={handleInputChange}
        isLoading={isLoading}
        releaseType={`ポートフォリオ名 / ふりがな`}
      >
        <FetchContainer person={person} />
        {/* <SinglePerson
          id={person?.id}
          owner={person?.owner}
          ownerName={person?.ownerName}
          ownerChatDenial={person?.ownerChatDenial}
          img={
            person?.imgs?.[0]?.large?.url
              ? person.imgs[0].large.url
              : getDefaultImage()
          }
          name={person?.name}
          game={person?.game}
          team={person?.team?.[0] && person.team[0]}
          playerTypeName={person?.player_type?.[0]?.name}
          profile={person?.profile}
          birthplace={person?.birthplace}
          height={person?.height}
          weight={person?.weight}
          hobby={person?.hobby}
          history={person?.history}
          works={person?.works}
          twitter={person?.sns?.twitter?.toString()}
          instagram={person?.sns?.instagram?.toString()}
          facebook={person?.sns?.facebook?.toString()}
          youtube={person?.sns?.youtube?.toString()}
          twitch={person?.sns?.twitch?.toString()}
          school={person?.school}
          course={person?.course}
          verified={person?.verified}
          followers={followerData}
          isSNSLoading={isSNSLoading}
          showOfferButton={false}
          members={
            // 公開申請はisLoading trueでもchildrenのpropsを検証するのでフェッチが終わった時のみ判定する
            // storeのデータとidが一致するときのみ自分を除いて表示
            // !isLoading && person.id === id
            //   ? members.filter((member) => member.id !== id)
            //   : []
            []
          }
        /> */}
      </ReleasePreview>
    </>
  );
};
